import { fetchRepeatRoster } from "@Services/api";
import { CloseCircleOutlined } from "@ant-design/icons";
import { message } from "antd";
import React from "react";

interface ModalProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  data?: {
    brandId: number;
    brandName: string;
    buttonTxt: string;
    image: string;
    kindId: number;
    price: string;
    title: string;
    id: number;
  };
}

const CompeteModal: React.FC<ModalProps> = ({ visible, setVisible, data }) => {
  const onClose = () => {
    setVisible(false);
  };

  const handleSubmit = async (e) => {
    e.stopPropagation();
    const res = await fetchRepeatRoster({ inquiryId: data?.id, b: data?.brandId, k: data?.kindId });
    if (res.status === 12000) {
      message.success(res.data.message);
      onClose?.();
      return;
    }
    message.error(res.message || res.data.message);
  };

  if (!visible || !data) {
    return <></>;
  }

  return (
    <div
      className='fixed left-0 right-0 top-0 bottom-0 bg-[rgba(0,0,0,0.5)] flex justify-center items-center'
      style={{ zIndex: 1 }}
    >
      <div
        className='w-572 h-524 bg-[url(https://photo.8891.com.tw/2023/08/02/1690957619307937.png)] bg-contain relative'
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className='absolute left-120 top-100 flex flex-col items-center w-330'>
          <div className='text-16 font-[#333] font-normal text-center h-44'>{data?.title}</div>
          <img src={data?.image} className='w-300 h-200' />
          <div className='text-18 font-medium text-[#333] mt-10'>{data?.brandName}</div>
          <div className='text-16 font-normal text-[#ff4333] mt-6'>{data?.price}</div>
        </div>
        <div
          className='absolute h-50 bottom-54 text-20 w-330 flex items-center justify-center left-120 text-[#fff] font-medium cursor-pointer'
          onClick={handleSubmit}
        >
          {data?.buttonTxt}
        </div>
        <div className='absolute -bottom-50 cursor-pointer' style={{ left: "48%" }} onClick={onClose}>
          <CloseCircleOutlined className='text-[#fff] text-30' />
        </div>
      </div>
    </div>
  );
};

export default CompeteModal;
